<template>
    <div>
        <button v-if="loading === true" disabled class="app-btn btn btn-primary center-block">
            <span  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
        </button>
        <button v-else  class="app-btn btn btn-primary center-block">{{title}}</button>
    </div>
</template>

<script>
    export default {
        props:['loading','title'],
        name: "BaseButton"
    }
</script>

<style scoped>

</style>